import { memo } from 'react'
import { useIntl } from 'react-intl'

import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

function PropertyGuestPublicRateSignUpPrompt() {
  const intl = useIntl()

  return <BodyTextBlock variant="medium" weight="bold" colour="light-foreground-alt" startIcon={<LineTagAltIcon />}>
    {intl.formatMessage({
      id: 'ZT8JFk9eNyCHub0nZhRC',
      defaultMessage: 'Sign up to access exclusive rates',
      description: 'Prompt underneath public(/B2C) rate pricing shown to logged-out users, hinting that logging in may reveal cheaper non-public(/CUG) rate pricing',
    })}
  </BodyTextBlock>
}

export default memo(PropertyGuestPublicRateSignUpPrompt)
